import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Hotels from './pages/Hotels';
import Bookings from './pages/Bookings';
import Users from './pages/Users';
import Coupons from './pages/Coupons';
import Transactions from './pages/Transactions';
import Reports from './pages/Reports';
import Commission from './pages/Commission';
import Login from './pages/Login';
import TestAPI from './pages/TestAPI';
import Accessibility from './pages/Accessibility';
import Partners from './pages/Partners';
import Amenities from './pages/Amenities';
import Testimonials from './pages/Testimonials';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/test-api" element={<TestAPI />} />
          <Route path="/" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route index element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="hotels" element={
              <ProtectedRoute>
                <Hotels />
              </ProtectedRoute>
            } />
            <Route path="hotels/commission" element={
              <ProtectedRoute requiredRole="super_admin">
                <Commission />
              </ProtectedRoute>
            } />
            <Route path="bookings" element={
              <ProtectedRoute>
                <Bookings />
              </ProtectedRoute>
            } />
            <Route path="users" element={
              <ProtectedRoute requiredRole="super_admin">
                <Users />
              </ProtectedRoute>
            } />
            <Route path="coupons" element={
              <ProtectedRoute>
                <Coupons />
              </ProtectedRoute>
            } />
            <Route path="transactions" element={
              <ProtectedRoute requiredRole="super_admin">
                <Transactions />
              </ProtectedRoute>
            } />
            <Route path="reports" element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            } />
            <Route path="accessibility" element={
              <ProtectedRoute requiredRole="super_admin">
                <Accessibility />
              </ProtectedRoute>
            } />
            <Route path="partners" element={
              <ProtectedRoute requiredRole="super_admin">
                <Partners />
              </ProtectedRoute>
            } />
            <Route path="amenities" element={
              <ProtectedRoute>
                <Amenities />
              </ProtectedRoute>
            } />
            <Route path="testimonials" element={
              <ProtectedRoute requiredRole="super_admin">
                <Testimonials />
              </ProtectedRoute>
            } />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;